<template>
    <div class="aboutNews">
        <div class="newsNav">
            <ul>
                <li class="checked"><span>{{$t("trade.products.aboutNews")}}</span><p></p></li>
            </ul>
        </div>
        <div class="newsCon">
            <ul>
                <li v-for="news in newList" @click="geDetail(news)">
                    <span>{{news.title}}</span>
                    <time>{{news.ctime|time}}</time>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    require('@/assets/css/news.css');
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import api from '@/plugins/api'
    export default {
        name: "AboutNews",
        props:['code','locale'],
        filters: {
            time(longTime) {
                return Util.formatDate(longTime,"yyyy-MM-dd hh:mm:ss");
            }
        },
        computed:{
            ...mapState(['quote']),
            newList:{
                get(){
                    if (this.newsArr.length > 0 || this.getNewList) return this.newsArr;
                    if (this.quote.notify[this.code] && this.quote.notify[this.code].szShortName) {
                        this.getNewList = false;
                        this.getNews(this.quote.notify[this.code].szShortName);
                    }
                    return [];
                }
            }
        },
        data(){
            return{
                newsArr:[],
                getNewList:false,//异步请求数据标识
                lang:''
            }
        },
        methods:{
            getNews(symbol){
                if (this.locale == "vn") {
                    this.lang = 'vi-VN'
                } else {
                    this.lang = 'en-US'
                }
                let data = {
                    limit: 5,
                    codes: symbol,
                    lang: this.lang
                };
                api.product(this.$qs.stringify(data)).then(res => {
                    if (res.status == 200 && res.data.code == 200) {
                        this.newsArr = res.data.ch_msg;
                        this.getNewList = true;
                    }
                })
            },
            geDetail(news) {
                this.$bus.$emit('loading', false);
                this.$router.push({
                    path: "/home/NewsDetail",
                    query: {
                        id: news.id,
                        title: ""
                    }
                });
            },
        },
        watch:{
            code(newData,oldData){
                if (this.quote.notify[newData] && this.quote.notify[this.code].szShortName) {
                    this.getNews(this.quote.notify[newData].szShortName);
                }
            }
        }
    }
</script>
